import { styled } from '@mui/system';
import TableCell from '@mui/material/TableCell';

export const IconCnt = styled('div')({
  lineHeight: '1em',
  display: 'inline-block',
  verticalAlign: 'middle',
  marginRight: 8
});

export const LabelCell = styled(TableCell)({
  wordBreak: 'break-word',
  padding: '8px 0',
  '& div:first-of-type': {
    color: 'black',
    maxWidth: 400
  },
  width: 'auto',
  height: 57,
  paddingLeft: 15
});

export const TitleWithSubtitle = styled('div')({
  '& div': {
    lineHeight: 1.3
  },
  '& div:nth-of-type(2)': {
    fontSize: 'smaller',
    color: '#0000008a'
  }
});

export const DeviceCell = styled(TableCell)({
  padding: '0 20px 0 16px !important'
});

export const DevicesCell = styled(TableCell)(({ theme }) => ({
  padding: '8px 20px 8px 16px !important',
  '& div a + a': {
    marginBottom: theme.spacing()
  }
}));

export const WordBreakCell = styled(TableCell)({
  wordBreak: 'break-word'
});

export const ThStatusCell = styled(TableCell)({
  position: 'relative',
  '& span': {
    position: 'absolute',
    top: 19,
    left: 14
  },
  '& svg': {
    marginLeft: 2
  }
});

export const AddressCellEmpty = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));

export const AddressCell = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(),
  paddingBottom: theme.spacing()
}));

export const chipStyle = theme => ({
  marginRight: theme.spacing(),
  marginBottom: '1px',
  marginTop: '1px',
  maxWidth: 'fit-content'
});

export const chipRootStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '240px'
};
